import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Feature } from '../../Feature'

import { IProps } from './IProps'

export const PackageList = ({ features }: IProps) => {
  const { t } = useTranslation()

  return (
    <>
      {features.map(feature => (
        <Feature key={feature} fontColor={'black'} fontStyle={'bold'}>
          <FontAwesomeIcon
            icon={faCheck}
            color={'#145CD6'}
            style={{ marginRight: '0.5em' }}
          />
          {t(feature)}
        </Feature>
      ))}
    </>
  )
}
